<template>
    <div id="mobileCert">
        <div class="certBox-item-title">
                      {{list.title}} 
              </div>
            <div class="certBox-item-content">
                        <div class="certBox-item-content-1">
                               {{list.content}}
                        </div>
                        <div class="certBox-item-content-2">
                            <img 
                             :src="list.pic"
                                alt="" 
                                >
                            <div class="certBox-item-content-2-name">
                           {{list.recipientName}} 
                            </div>
                        </div>
                    </div>
                <div class="certBox-item-box flex">
                    <div class="certBox-item-info">
                           <div class="certBox-item-info-item">
                    <div class="certBox-item-info-item-top flex ">
                        <div class="top-label" style="letter-spacing:14px">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</div>
                        <div class="top-val" style="margin-left: -9px;">
                            {{list.sex == 1 ? '男' : '女'}}
                        </div>
                    </div>
                    <div class="certBox-item-info-item-bot">
                        Gender
                    </div>
                </div>
                   <div class="certBox-item-info-item">
                    <div class="certBox-item-info-item-top flex ">
                        <div class="top-label">出生日期:</div>
                        <div class="top-val">
                           {{list.birthDate}}
                        </div>
                    </div>
                    <div class="certBox-item-info-item-bot">
                        Date of Birth
                    </div>
                </div>
            <div class="certBox-item-info-item">
                    <div class="certBox-item-info-item-top flex ">
                        <div class="top-label">证书专业:</div>
                        <div class="top-val">
                            {{list.certMajor}}
                        </div>
                    </div>
                    <div class="certBox-item-info-item-bot">
                        Certificate Major
                    </div>
                </div>
                                          <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">证书等级:</div>
                                <div class="top-val">
                                    {{list.certLevel}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                                 Certificate Level
                            </div>
                        </div>
                  <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">证书编号:</div>
                                <div class="top-val">
                                    {{list.certificateNo}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                                Certificate Number
                            </div>
                        </div>
                      <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证机构:</div>
                                <div class="top-val top-val1">
                                    （盖章）
                                    <img 
                                    :src="list.institutionSignet"
                                     alt="" 
                                    class="top-val-img">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                               Issuing Authority (Seal)
                            </div>
                        </div>
                         <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证日期:</div>
                                <div class="top-val">
                                    {{list.issueTime}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                              Date of Issue
                            </div>
                        </div>
            </div>
                </div>
                <!-- <div class="certBox-item-info-item-db flex">
                             <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证机构负责人(签章):</div>
                                <div class="top-val2">
                                     <img 
                                      :src="list.principalSignet"
                                      alt="" 
                                     alt="" class="top-val-img1">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                             Person in Charge of Issuing Authority
                            </div>
                        </div>
                </div> -->
    </div>
</template>
<script>
import {getReceive} from "@/api/index/index"  //查询领取人详情
export default {
    name:'mobileIndex',
    data() {
        return {
            list:{}
        }
    },
    created () {
        if(this.$util.isMobile()){
            this.getCertDetail()
        }else{
            this.$router.replace({
                name:'enCert',
                query:{
                    certId:this.$route.query.id
                }
            })
        }
        
    },
    methods: {
          // 证书详情
        getCertDetail(){
            let id = this.$route.query.id;
             getReceive({id:id},'get')
            .then(res =>{
               this.list = res.data
               document.title = `${res.data.recipientName}-${res.data.title}`
            })
            .catch(err =>{})
        },
    },
}
</script>
<style lang="scss" scoped>
#mobileCert{
    margin-top: -56px;
    width: 100%;
    height: 100vh;
    background: url("../../assets/images/moCertBG.jpg") no-repeat 0 0 ;
    background-size: 100% 100%;
    .certBox-item-title{
        padding-top: 11vh;
        font-size: 7vw;
        font-weight: bold;
        letter-spacing: 1vw;
        text-align: center;
    }
    .certBox-item-content{
        padding-top: 1vh;
        .certBox-item-content-1{
            width: 67vw;
            margin: 0 auto;
            font-size: 4vw;
            line-height: 3vh;
            color: #000;
        }
        .certBox-item-content-2{
            padding-top: 3vh;
            img{
                width: 22vw;
                height: 14vh;
                margin: 0 auto;
                display: block;
            }
            .certBox-item-content-2-name{
                color: #000000;
                font-size: 4vw;
                text-align: center;
                padding-top: 2vh;
            }
        }
    }
    .certBox-item-box{
            padding-top: 1vh;
            justify-content: center;
        .certBox-item-info{
         .certBox-item-info-item{
            .certBox-item-info-item-top{
                    .top-label{
                        letter-spacing: 5px;
                        line-height: 3vh;
                        color: #000000;
                        font-size: 3vw;
                    }
                     .top-val{
                        width:40vw ;
                        text-align: center;
                        font-size: 3vw;
                        line-height: 3vh;
                        color: #000000;
                        border-bottom: 2px solid #000;
                        position: relative;
                        .top-val-img{
                            width: 21vw;
                            height: 21vw;
                            border-radius: 50%;
                            position: absolute;
                            right:0px; 
                            z-index: 999;
                            top: 0vh;
                        }
                       
                    }
                    .top-val3{
                        width: auto;
                        padding-left: 90px;
                        font-size: .8vw;
                    }
                    .top-val1{
                        border-bottom: none;
                        text-align: left;
                    }
            }
              .certBox-item-info-item-bot{
                     font-size: 2.5vw;
                    line-height: 1.5vh;
                    font-style: italic;
                }
         }
    }
    }
    .certBox-item-info-item-db{
        justify-content: center;
           .certBox-item-info-item-top{
                    .top-label{
                        letter-spacing: 5px;
                        line-height: 4vh;
                        color: #000000;
                        font-size: 3.5vw;
                    }
                     .top-val{
                        width:40vw ;
                        text-align: center;
                        font-size: 3.5vw;
                        line-height: 4vh;
                        color: #000000;
                        border-bottom: 2px solid #000;
                        position: relative;
                        .top-val-img{
                            width: 21vw;
                            height: 21vw;
                            border-radius: 50%;
                            position: absolute;
                            right:0px; 
                            z-index: 999;
                            top: 3vh;
                        }
                       
                    }
                    .top-val3{
                        width: auto;
                        padding-left: 90px;
                        font-size: .8vw;
                    }
                    .top-val1{
                        border-bottom: none;
                        text-align: left;
                    }
            }
        .certBox-item-info-item-bot{
                     font-size: 3vw;
                    line-height: 2vh;
                    font-style: italic;
                }
                              .top-val2{
                        position: relative;
                         width: 15vw;
                            height: 3vh;
                         .top-val-img1{
                            width: 15vw;
                            height: 3vh;
                            position: absolute;
                        }
                    }
    }
    
}
</style>